import { render, staticRenderFns } from "./section-container.vue?vue&type=template&id=21909844&"
import script from "./section-container.vue?vue&type=script&lang=ts&"
export * from "./section-container.vue?vue&type=script&lang=ts&"
import style0 from "./section-container.vue?vue&type=style&index=0&id=21909844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports